module.exports = __webpack_public_path__ + "static/media/DKTN.6a5c51fb.svg";